module.exports = __webpack_public_path__ + "img/applet-icon.0edcbe59.svg";